<template>
  <div>
    <v-row>
      <v-col cols="12">
        <h3>{{ $t('auto.labels.technicalCondition') }}</h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="5" class="complectation-column">
        <v-row v-for="item in equipmentList.firstSection" :key="item[0]">
          <v-col cols="7" class="mt-1">
            {{ item[1] }}
          </v-col>
          <v-col class="d-flex" cols="5">
            <v-select
              :items="propertyItems"
              v-model="credentials[item[0]]"
              item-text="title"
              item-value="id"
              class="mt-0 pt-0"
              @change="
                onItemChange({
                  param: item[0],
                  value: $event,
                  comment: commentsData[item[0]],
                })
              "
            />

            <v-tooltip top>
              <template #activator="{ on, attrs }">
                <v-btn
                  :class="{ hidden: credentials[item[0]] !== '0' }"
                  class="ml-2"
                  color="warning"
                  v-on="on"
                  v-bind="attrs"
                  icon
                  @click="
                    () => {
                      commentDialog.opened = true;
                      commentDialog.param = item[0];
                      commentDialog.value = commentsData[item[0]];
                    }
                  "
                >
                  <v-icon>
                    mdi-comment-text
                  </v-icon>
                </v-btn>
              </template>

              <span v-if="commentsData[item[0]]">
                {{ commentsData[item[0]] }}
              </span>

              <i v-else>{{ $t('common.fields.commentAdd') }}</i>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-col>
      <v-col
        v-show="$vuetify.breakpoint.mdAndUp"
        class="text-center complectation-column"
      >
        <v-divider vertical></v-divider>
      </v-col>
      <v-col cols="12" sm="12" md="5" class="complectation-column">
        <v-row v-for="item in equipmentList.secondSection" :key="item[0]">
          <v-col cols="7" class="mt-1">
            {{ item[1] }}
          </v-col>
          <v-col class="d-flex" cols="5">
            <v-select
              :items="propertyItems"
              v-model="credentials[item[0]]"
              item-text="title"
              item-value="id"
              class="mt-0 pt-0"
              @change="
                onItemChange({
                  param: item[0],
                  value: $event,
                  comment: commentsData[item[0]],
                })
              "
            />

            <v-tooltip top>
              <template #activator="{ on, attrs }">
                <v-btn
                  :class="{ hidden: credentials[item[0]] !== '0' }"
                  v-on="on"
                  v-bind="attrs"
                  class="ml-2"
                  color="warning"
                  icon
                  @click="
                    () => {
                      commentDialog.opened = true;
                      commentDialog.param = item[0];
                      commentDialog.value = commentsData[item[0]];
                    }
                  "
                >
                  <v-icon>
                    mdi-comment-text
                  </v-icon>
                </v-btn>
              </template>

              <span v-if="commentsData[item[0]]">
                {{ commentsData[item[0]] }}
              </span>

              <i v-else>{{ $t('common.fields.commentAdd') }}</i>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <text-field-edit-dialog
      v-model="commentDialog.opened"
      :param-name="commentDialog.param"
      :currentValue="commentDialog.value"
      :label="$t('common.fields.comment')"
      @save="
        (event) => {
          commentsData = { ...commentsData, ...event };
        }
      "
    />
  </div>
</template>

<script>
import TextFieldEditDialog from '@/components/shared/TextFieldEditDialog.vue';

export default {
  components: { TextFieldEditDialog },
  name: 'CheckList',
  props: {
    technicalCondition: Object,
    comments: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      credentials: {},
      commentsData: {},
      commentDialog: {
        opened: false,
        param: '',
        value: '',
      },
    };
  },
  computed: {
    propertyItems() {
      return [
        {
          id: null,
          title: this.$t('common.absent'),
        },
        {
          id: '0',
          title: this.$t('common.faulty'),
        },
        {
          id: '1',
          title: this.$t('common.serviceable'),
        },
      ];
    },
    equipmentList() {
      const { checkList } = this.$store.state.auto.autosState;
      const array = Object.entries(checkList || {});
      const middleIdx = Math.ceil(array.length / 2);

      return {
        firstSection: array.slice(0, middleIdx),
        secondSection: array.slice(middleIdx),
      };
    },
  },
  methods: {
    getComponentData() {
      this.$emit('update:technicalCondition', this.credentials);
      this.$emit('update:comments', this.commentsData);
    },
    writeDataToFields({ data, comments }) {
      this.credentials = data;
      this.commentsData = comments;
    },
    onItemChange({ param, value, comment }) {
      if (value === '0') {
        this.commentDialog.opened = true;
        this.commentDialog.param = param;
        this.commentDialog.value = comment;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
h3 {
  margin-top: 20px;
  margin-bottom: 10px;
  font-weight: 300;
}
.hint {
  color: #bababa;
}
.complectation-column {
  padding-top: 0;
  padding-bottom: 0;
}
.hidden {
  opacity: 0;
  pointer-events: none;
}
</style>
